export function fromLatin1(contents: string) {
  const bytes = new Uint8Array(contents.length);

  for (let i = 0; i < contents.length; i++) {
    bytes[i] = contents.charCodeAt(i);
  }

  return bytes;
}
